import { appColors } from "@/common/AppConst";
import { CalculateStatus, CountResultTip } from "@/pages/check/CheckPage";
import { RootState } from "@/vuex-store";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CountTextLenMixin extends Vue {
    /**
     * 当前编辑器内文本长度
     */
    textLength: number = 0;
    /**
     * 当前编辑框的内容消耗的纠错次数
     */
    correctCountToPay: number = 0;
    /**
     * 计算纠错次数操作的状态
     */
    calculateCountStatus: CalculateStatus = CalculateStatus.success;
    /**
     * 计算纠错次数失败的信息
     */
    calculateFailTipObj: CountResultTip | null = null;

    /**
     * 短文本纠错时的最大长度
     */
    get maxLenOnceCorrect(): number {
        return (
            (this.$store.state as RootState).appConfigs?.maxLenOnceCorrect || 0
        );
    }

    /**
     * 长文本纠错最大消耗纠错次数
     */
    get maxPayCountOnce(): number {
        return (
            (this.$store.state as RootState).appConfigs?.maxPayCountOnce || 0
        );
    }

    /**
     * 总字数提示文本
     */
    get totalTextLenMsg(): string {
        return `总字数：${this.textLength}`;
    }

    /**
     * 长文本模式单次请求消耗次数限制提示文本
     */
    get countLimitMsg() {
        return (
            "单次长文本纠错消耗的纠错次数不能超过" + this.maxPayCountOnce + "次"
        );
    }

    /**
     * 普通模式字数限制提示文本
     */
    get lenLimitMsg() {
        return `检测文本总字数不能超过${this.maxLenOnceCorrect}个`;
    }

    /**
     * 不显示纠错功能时字数提示的信息
     */
    get onlyTotalLenTipObj(): CountResultTip {
        return {
            text: this.totalTextLenMsg,
            color: appColors.infoColor,
            showRecalculate: false,
        };
    }

    /**
     * 正在计算纠错次数时提示的信息
     */
    get calculateIngTipObj(): CountResultTip {
        return {
            text: `${this.totalTextLenMsg}，纠错次数计算中...`,
            color: appColors.infoColor,
            showRecalculate: false,
        };
    }

    /**
     * 计算纠错次数异常情况时提示的信息
     */
    get defaultCalculateFailTipObj(): CountResultTip {
        return {
            text: `${this.totalTextLenMsg}，计算纠错次数失败`,
            color: appColors.dangerColor,
            showRecalculate: true,
        };
    }

    /**
     *超出长文本单次纠错操作消耗的纠错次数的提示
     */
    get overPayCountTipObj() {
        return {
            text:
                `${this.totalTextLenMsg}，` +
                this.countLimitMsg +
                "，当前文章会消耗" +
                this.correctCountToPay +
                "次",
            color: appColors.dangerColor,
            showRecalculate: false,
        };
    }

    /**
     * 正常计算纠错次数后提示的信息
     */
    get normalPayCountTipObj() {
        const text =
            this.totalTextLenMsg +
            `，消耗纠错次数：${this.correctCountToPay}/${this.maxPayCountOnce}`;
        const isMax = this.maxPayCountOnce == this.correctCountToPay;
        const color = isMax ? appColors.warningColor : appColors.successColor;
        return { text, color, showRecalculate: false };
    }

    /**
     * 普通模式超出文本长度时的提示
     */
    get overTextLenTipObj() {
        return {
            text:
                `${this.lenLimitMsg}，当前有${this.textLength}` +
                "个，需要检测长文本可进入长文本模式",
            color: appColors.dangerColor,
            showRecalculate: false,
        };
    }

    /**
     * 普通模式
     */
    get normalTextLenTipObj() {
        return {
            text: `${this.totalTextLenMsg}/最大字数：${this.maxLenOnceCorrect}`,
            color: appColors.successColor,
            showRecalculate: false,
        };
    }

}
